import { useState } from 'react';
import NOOP from '../utils/NOOPUtils';
function useModal(initialIsVisible = false, initialIsCloseModalEnabled = true, onCloseModal = NOOP) {
    const [isVisible, setIsVisible] = useState(initialIsVisible);
    const [isCloseModalEnabled, setIsCloseModalEnabled] = useState(initialIsCloseModalEnabled);
    const openModal = () => {
        setIsVisible(true);
    };
    const closeModal = () => {
        if (!isCloseModalEnabled)
            return;
        setIsVisible(false);
        onCloseModal();
    };
    const enableCloseModal = () => {
        setIsCloseModalEnabled(true);
    };
    const disableCloseModal = () => {
        setIsCloseModalEnabled(false);
    };
    return { isVisible, isCloseModalEnabled, openModal, closeModal, enableCloseModal, disableCloseModal };
}
export default useModal;
//# sourceMappingURL=useModal.js.map